enum APP_ROLES {
  USER = 'user',
  ADMIN = 'admin',
  ADMIN_ACCQSURE = 'admin:accqsure',
}

export default APP_ROLES;
